<template>
  <div>
    <div class="thank-you-content align-justify pt40 pl20">
      <div class="container">
        <div class="row">
          <div class="col-md-6 desktop">
            <div class="image-location">
              <img src="/assets/home-location.png" class="image-improvment" width="591" height="289" loading="eager" fetchpriority="high" alt="Thank you for your order!">
            </div>
          </div>
          <div class="col-md-6 block-info-order pl20 pr20">
            <h3 v-if="OnlineOnly" class="confirmation-order">
              {{ $t('Order confirmation') }}
            </h3>
            <p class="info-order mb5" v-if="locationCode.code !== 'lutsk' && OnlineOnly"
               v-html="this.$t('Thank you for your order! An email with confirmation and order details has been sent to your email address.')"
            />
            <p class="info-order mb5" v-else-if="OnlineOnly">
              {{ $t('Thank you for your order!') }}<br>
              <b>{{ $t('Please, wait for the courier to call.') }}</b><br>
              {{ $t('An email with confirmation and order details has been sent to your email address.') }}
            </p>
            <p class="my0" v-if="lastOrderConfirmation.magentoOrderId">{{ $t('The Order Number is:') + ' ' }} <span class="number-order">{{lastOrderConfirmation.magentoOrderId}}</span></p>
            <h4 v-if="OfflineOnly">
              {{ $t('You are offline') }}
            </h4>
            <p v-if="OfflineOnly && !isNotificationSupported">
              {{ $t('To finish the order just come back to our store while online. Your order will be sent to the server as soon as you come back here while online and then confirmed regarding the stock quantities of selected items') }}
            </p>
            <p v-if="OfflineOnly && isNotificationSupported && !isPermissionGranted">
              {{ $t("You can allow us to remind you about the order via push notification after coming back online. You'll only need to click on it to confirm.") }}
              <button-outline
                class="mt10"
                color="dark"
                @click.native="requestNotificationPermission"
              >
                {{ $t('Allow notifications') }}
              </button-outline>
            </p>
            <p v-if="OfflineOnly && isNotificationSupported && isPermissionGranted">
              <strong>{{ $t('You will receive Push notification after coming back online. You can confirm the order by clicking on it') }}</strong>
            </p>
            <p>
            </p>
            <div id="thank-you-extensions" />
          </div>
          <div class="col-xs-12 mobile">
            <div class="image-location">
              <img src="/assets/home-location.png" class="image-improvment">
            </div>
          </div>
          <div class="col-md-12 thank-you-improvment">
            <h3 class="center-md center-xs title-improve">
              {{ $t('What we can improve?') }}
            </h3>
            <p class="mb25 center-md center-xs feedback">
              {{ $t('Your feedback is important for us. Let us know what we could improve.') }}
            </p>
            <form @submit.prevent="sendFeedback">
              <div class="textarea-box textarea-wrapper col-xs-12 center-md start-xs">
                <base-textarea
                  rows="4"
                  cols="10"
                  type="text"
                  class="textarea-custom-success-anywhere col-md-12"
                  v-model="feedback"
                  @blur="$v.feedback.$touch()"
                  maxlength="10000"
                  data-hj-whitelist
                  :placeholder="this.$t('Your feedback')"
                  :validations="[
                    {
                    condition: $v.feedback.$error && !$v.feedback.required,
                    text: $t('Field is required')
                    }
                  ]"
                />
              </div>
              <div class="col-md-4 col-xs-12 button-response">
                <button type="button" class="text-button-feedback bg-cl-korzyna-green block brdr-none button-full center-lg cl-white h6 mb no-outline
                                place-order-btn px10 py10 ripple sans-serif weight-400 "
                        @click="sendFeedback"
                >
                  {{ $t('Submit feedback') }}
                </button>
              </div>

            </form>
            <div class="back-to-shop col-md-12 col-xs-12 cl-secondary">
              <router-link :to="localizedRoute('/')">{{ $t('Return to shopping') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Composite from '@vue-storefront/core/mixins/composite'
  import Breadcrumbs from 'theme/components/core/Breadcrumbs'
  import BaseTextarea from 'theme/components/core/blocks/Form/BaseTextarea'
  import ButtonOutline from 'theme/components/theme/ButtonOutline'
  import VueOfflineMixin from 'vue-offline/mixin'
  import { EmailForm } from '@vue-storefront/core/modules/mailer/components/EmailForm'
  import { isServer } from '@vue-storefront/core/helpers'
  import {mapActions,mapGetters} from "vuex";
  import config from "config";
  import {required} from "vuelidate/lib/validators";

  export default {
    name: 'ThankYouPage',
    mixins: [Composite, VueOfflineMixin, EmailForm],
    props: {
      telephone: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        feedback: '',
        message : true,
        customer: this.$store.state.user.current,
        notificationPermission: (!isServer && 'Notification' in window) ? Notification.permission : 'default'
      }
    },
    validations: {
      feedback:{
        required
      }
    },
    computed: {
      lastOrderConfirmation () {
        return this.$store.state.order.last_order_confirmation ? this.$store.state.order.last_order_confirmation.confirmation : {}
      },
      isNotificationSupported () {
        if (isServer || !('Notification' in window)) return false
        return 'Notification' in window
      },
      isPermissionGranted () {
        if (isServer || !('Notification' in window)) return false
        return this.notificationPermission === 'granted'
      },
      checkoutPersonalEmailAddress () {
        return this.$store.state.checkout.personalDetails.emailAddress
      },
      checkoutPersonalName () {
        return this.$store.state.checkout.personalDetails.firstName
      },
      mailerElements () {
        return config.mailer.contactAddress
      },
      ...mapGetters({
        locationCode : 'locations/getActiveLocation'
      })
    },
    mounted() {
      this.resetState();
    },
    methods: {
      async requestNotificationPermission () {
        if (isServer || !('Notification' in window)) return false
        if (Notification.permission !== 'granted') {
          this.notificationPermission = await Notification.requestPermission()
        }
      },
      sendFeedback () {
        if (this.$v.$invalid){
          this.showErrors('Fill in the comment field')
        }else {
          this.addReview({
            customer_id: this.customer ? this.customer.id : 0,
            customer_name: this.checkoutPersonalName,
            customer_email: this.checkoutPersonalEmailAddress,
            location_code: this.locationCode.code,
            text: this.feedback
          }).then(sent => {
            if (sent) this.resetForm();
          })
        }
      },
      resetForm () {
        this.feedback = '';
        this.$v.$reset();
      },
      showErrors (messageError) {
        this.$v.feedback.$touch();
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: this.$t(messageError),
          action1: {label: this.$t('OK')}
        })
      },
      onFailure (message) {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message,
          action1: { label: this.$t('OK') }
        })
      },
      ...mapActions({
        resetState: 'partners/resetCurrentPartner',
        addReview: 'review/add'
      })
    },
    deactivated () {
      this.$store.dispatch('pickup-checkout/setThankYouPage', false);
    },
    components: {
      BaseTextarea,
      Breadcrumbs,
      ButtonOutline
    }
  }
</script>

<style lang="scss">
  .textarea-custom-success-anywhere {
    label{
      left: 15px !important;
      top: 20px !important;
    }
    textarea {
      height: 60px;
      border-radius: 5px;
      border: solid 1px #bdbdbd;
      background-color: #ffffff !important;
      resize: none;
      font-family: 'TTNorms Regular', sans-serif;
      padding: 15px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.09px;
      &:focus {
        ~ {
          label {
            top: 10px !important;
            font-size: 14px !important;
          }
        }
      }
      &:not(.empty) {
        ~ {
          label {
            top: 10px !important;
            font-size: 14px !important;
          }
        }
      }
      &.error{
        border: solid 1px #bdbdbd !important;
      }
    }
  }
</style>
<style scoped lang="scss">
  .thank-you-content {
    padding-left: 0;

    p {
      line-height: 25px
    }

    @media (min-width: 64em) {
      h4 {
        font-size: 24px;
      }
    }
  }
  .thank-you-improvment {
    padding: 0 20px 15px;

    @media (min-width: 64em) {
      padding: 0 40px 10px;
    }
  }
  .confirmation-order{
    font-size: 34px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.28px;
    margin-bottom: 0;
    @media (max-width: 600px) {
      font-size: 24px;
      letter-spacing: 0.2px;
      margin-top: 0;
    }
  }
  .info-order{
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.11px;
    @media (max-width: 1023px) {
      margin-top: 5px;
    }
  }
  .title-improve{
    font-size: 21px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.09px;
    margin-bottom: 0;
  }
  .feedback{
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.07px;
    margin-top: 5px;
    @media (max-width: 600px) {
      font-size: 14px;
    }
  }

  .button-response{
    margin: 0 auto;
    margin-top: 20px;
  }
  .text-button-feedback{
    font-size: 12px;
    font-weight: 500;
    width: 100%;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.05px;
    padding: 13px;
  }
  .checkbox-text{
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.06px;
  }
  .desktop{
    @media (max-width: 1023px) {
      display: none;
    }
  }
  .mobile{
    display: none;
    @media (max-width: 1023px) {
      display: block;
      text-align: center;
    }
  }
  .image-improvment{
    width: 100%;
    object-fit: contain;
    @media (max-width: 1023px) {
      width: auto;
    }
    @media (max-width: 676px) {
      width: 100%;
    }
  }
  .block-info-order.col-md-6{
    @media (max-width: 1023px) {
      flex-basis: 100%;
      max-width: 100%;
      margin: 0 auto;
      text-align: center;
    }
  }
  .checkbox-message{
    justify-content: flex-start;
    text-align: start;
    @media (max-width: 1023px) {
      flex-basis: 45%;
      max-width: 45%;
      margin: 0 auto;
      justify-content: center;
      text-align: center;
    }
    @media (max-width: 768px) {
      flex-basis: 62%;
      max-width: 62%;
    }
    @media (max-width: 516px) {
      flex-basis: 180%;
      max-width: 80%;
    }
    @media (max-width: 400px) {
      flex-basis: 100%;
      max-width: 100%;
    }
  }
  .number-order{
    font-weight: 500;
    color: #11bb2e;
  }
  .back-to-shop{
    text-align: center;
    margin-top: 30px;
  }
</style>
